<template>
  <div id="scroll-select-content" class="scroll-select-content" v-bind:style="contentStyleObject">
    <div class="scroll-select-item" v-bind:style="itemStyleObject"></div>
    <div class="scroll-select-item" v-bind:style="itemStyleObject"></div>
    <div
      class="scroll-select-item"
      v-bind:style="itemStyleObject"
      v-for="(item) in selectArr"
      :key="item.key"
      @click="clickSelect(item.key)"
    >
      <span v-bind:style="valueStyleObject">{{T(item.value || 'None')}}</span>
    </div>
    <div class="scroll-select-item" v-bind:style="itemStyleObject"></div>
    <div class="scroll-select-item" v-bind:style="itemStyleObject"></div>
  </div>
</template>

<script>
export default {
  name: "scroll-select",
  props: {
    selectArr: {
      type: Array,
      default: [{ key: null, value: "null" }]
    },
    selecKey: null,
    height: {
      type: Number,
      default: 0.86
    },
    rowNnm: {
      type: Number,
      default: 5
    },
    valueStyle: {
      type: Object,
      default() {
        return {
          fontFamily: "NotoSansHans-Bold",
          fontSize: "0.36rem",
          fontWeight: "normal",
          fontStretch: "normal",
          letterSpacing: "0rem",
          color: " #ecf2f7"
        };
      }
    },
    unit: {
      type: String,
      default: "rem"
    }
  },
  data() {
    return {};
  },
  watch: {
    selecKey() {
      this.init(document.getElementById("scroll-select-content"))
    }
  },
  created() {
    setTimeout(() => {
      var content = document.getElementById("scroll-select-content");
      if (content) {
        this.init(content);
        content.addEventListener("scroll", this.ajacs(100));
      }
    }, 10);
  },
  beforeDestroy() {
    var content = document.getElementById("scroll-select-content");
    if (content) {
      content.removeEventListener("scroll", this.ajacs(100));
    }
  },
  computed: {
    contentStyleObject: function() {
      return { height: this.height * this.rowNnm + this.unit };
    },
    itemStyleObject: function() {
      return {
        height: this.height + this.unit
      };
    },
    valueStyleObject: function() {
      return this.valueStyle;
    }
  },
  methods: {
    // 设置初始位置
    init(content) {
      let itemHeight = content.scrollHeight / (this.selectArr.length + 4);
      if (this.selecKey) {
        let index = this.selectArr.map(i => i.key).indexOf(this.selecKey);
        content.scrollTop = itemHeight * index;
      }
    },
    // 防抖定时器
    ajacs(times) {
      let time = null;
      let ajas = this.ajas;
      let selectArr = this.selectArr;
      return function() {
        if (time !== null) {
          clearTimeout(time);
        }
        let itemHeight = this.scrollHeight / (selectArr.length + 4);
        let scrollTop = this.scrollTop;
        time = setTimeout(() => {
          /* 事件结束开始执行最终方法*/
          return ajas(scrollTop, itemHeight);
        }, times);
      };
    },
    // 最终输出位置
    ajas(scrollTop, itemHeight) {
      //读取滚动条的位置
      /*itemHeight是每一块的高度，前面两个是空的从0开始算起，需要＋1才能符合当前位置*/
      let index = Math.round(scrollTop / itemHeight);
      if (this.selectArr) {
        let selectItem = this.selectArr[index];
        this.$emit("change", selectItem.key);
      }
    },
    clickSelect(key) {
      this.$emit("change", key);
      this.$emit('update:selecKey', key)
    }
  }
};
</script>

<style lang="scss">
.scroll-select-content {
  list-style: none;
  overflow: auto;
  scroll-snap-type: y mandatory;

  .scroll-select-item {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    color: #333;
    scroll-snap-align: start;
    cursor: pointer;
  }
  ::-webkit-scrollbar {
    display: none;
  }
}
</style>